
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoacabs() {



  const cardData =
  {
    keyword: 'Pune to Goa Cab Service',
    heading: 'AB Ghule Cabs: Pune to Goa Cab Service',
    headingDescription: 'AB Ghule Cabs provides reliable and comfortable Pune to Goa cab services, ensuring a smooth and enjoyable journey. Whether you are heading for a beach vacation, a cultural exploration, or a family getaway, we offer well-maintained vehicles and experienced drivers to make your trip seamless. With competitive prices and excellent customer service, we ensure a hassle-free ride to the beautiful state of Goa. Pune to Goa is approximately 450 km.',

    top: 'Top Places to Visit in Goa with AB Ghule Cabs',

    topPlaces: [
        {
          title: "Baga Beach",
          description: "Famous for its vibrant nightlife, water sports, and scenic beauty, Baga Beach is a must-visit destination for beach lovers and partygoers alike. The lively atmosphere, with numerous beach shacks and clubs, makes it a popular spot for those seeking both relaxation and adventure."
        },
        {
          title: "Fort Aguada",
          description: "A historical fort offering stunning views of the Arabian Sea, Fort Aguada is one of Goa’s most iconic landmarks. It also houses a lighthouse that is over 400 years old, making it a key site for history enthusiasts and those enjoying a scenic visit."
        },
        {
          title: "Dudhsagar Waterfalls",
          description: "Located in the Bhagwan Mahavir Wildlife Sanctuary, Dudhsagar Waterfalls is one of India’s tallest waterfalls and a popular spot for nature lovers and adventure seekers. The majestic falls, surrounded by lush greenery, are a great place for trekking and photography."
        },
        {
          title: "Church of St. Cajetan",
          description: "A beautiful example of baroque architecture, the Church of St. Cajetan in Old Goa is an UNESCO World Heritage Site and a peaceful place for reflection and exploration. The stunning interiors and serene surroundings offer a glimpse into Goa's colonial past."
        },
        {
          title: "Anjuna Beach",
          description: "Known for its laid-back vibe, Anjuna Beach is famous for its beach parties, vibrant markets, and artistic community. It's a perfect spot for relaxation and adventure, with numerous cafes, markets, and a blend of local culture."
        },
        {
          title: "Colva Beach",
          description: "Colva Beach is one of the most popular beaches in South Goa, known for its white sands, calm waters, and the perfect atmosphere for swimming and sunbathing. It is an excellent destination for a relaxed day by the sea, with plenty of nearby attractions."
        },
        {
          title: "Basilica of Bom Jesus",
          description: "This UNESCO World Heritage Site in Old Goa is one of the oldest churches in India and houses the mortal remains of St. Francis Xavier. The church's intricate architecture and historical significance make it a must-visit for spiritual and cultural exploration."
        },
        {
          title: "Vasco da Gama",
          description: "Vasco da Gama is a bustling town and a major port city. It is known for its beautiful beaches, Portuguese heritage, and vibrant culture. The town offers a mix of modern amenities and historical charm, with easy access to nearby beaches and attractions."
        },
        {
          title: "Palolem Beach",
          description: "Palolem is a crescent-shaped beach, known for its laid-back vibe, calm waters, and beautiful landscapes, making it an excellent spot for a quiet retreat. The palm-fringed beach offers a peaceful atmosphere ideal for unwinding and connecting with nature."
        },
        {
          title: "Salim Ali Bird Sanctuary",
          description: "Located on the island of Chorão, the Salim Ali Bird Sanctuary is a haven for bird watchers, with its rich diversity of avian species and lush mangrove forests. The sanctuary is a perfect spot for nature lovers and wildlife enthusiasts to explore Goa's unique ecosystems."
        }
      ],


      services: [
        {
          "name": "Pune to Goa Cab Service",
          description: "Looking for a reliable and affordable cab service from Pune to Goa? AB Ghule Cabs provides high-quality taxi services ensuring comfort and safety. Whether you're traveling solo or with family, we offer vehicles that are perfect for any group size. Book your cab today for a seamless experience!"
        },
        {
          "name": "Pune to Goa Taxi Booking",
          description: "With AB Ghule Cabs, booking your Pune to Goa taxi is hassle-free. Our online booking system allows you to easily reserve your ride at your convenience. Alternatively, you can call our helpline for quick bookings. Our customer service team is always ready to assist."
        },
        {
          "name": "Pune to Goa Rental Cabs",
          description: "Rent a cab from Pune to Goa with AB Ghule Cabs. We offer a range of vehicle options including budget-friendly models, luxury cars, and spacious SUVs. Our rental service gives you the freedom to travel at your own pace, with all the comfort you deserve."
        },
        {
          "name": "Pune to Goa One-Way Cab",
          description: "For those looking to travel one-way, AB Ghule Cabs offers convenient and affordable one-way cab services from Pune to Goa. You can rest assured that our professional drivers will make the trip enjoyable, with safe and punctual service all the way to your destination."
        },
        {
          "name": "Pune to Goa Round Trip Cabs",
          description: "Planning a round-trip journey to Goa? AB Ghule Cabs has you covered with affordable rates and comfortable cabs. We offer both one-way and return trips, so whether you need to come back the same day or after a few days, you can count on us for your return journey as well."
        },
        {
          "name": "Pune to Goa Luxury Taxi",
          description: "Travel in style and luxury with our premium taxi services from Pune to Goa. AB Ghule Cabs offers luxury vehicles for those who want a more opulent travel experience. From plush interiors to advanced features, enjoy the best of comfort during your journey."
        },
        {
          "name": "Pune to Goa Car Rental Services",
          description: "Looking for a car rental for your Pune to Goa trip? We offer an extensive fleet of cars for rent, including compact sedans, SUVs, and luxury vehicles. Whether you're traveling solo, with family, or in a group, we have a perfect car rental for your journey."
        },
        {
          "name": "Pune to Goa Taxi Fare",
          description: "The fare for your Pune to Goa taxi depends on your chosen vehicle type, travel distance, and duration. AB Ghule Cabs offers competitive pricing for all types of vehicles. We also ensure transparency, with no hidden charges so that you can budget your trip with confidence."
        },
        {
          "name": "Pune to Goa Cab Charges",
          description: "Our Pune to Goa cab charges are designed to be affordable while offering premium service. We provide clear breakdowns of all charges, so you know exactly what to expect. Whether you choose a basic sedan or a luxury car, the charges are structured for your convenience."
        },
        {
          "name": "Pune to Goa Taxi Service",
          description: "AB Ghule Cabs provides a premium taxi service from Pune to Goa, ensuring punctuality, comfort, and safety. Our experienced drivers are well-versed in the best routes, ensuring you reach your destination on time without any hassle."
        },
        {
          "name": "Pune to Goa Car Rental Service",
          description: "Need a rental car for your trip to Goa? AB Ghule Cabs offers flexible and affordable car rentals from Pune to Goa. Choose from a variety of vehicles based on your preferences, and travel in comfort. Our rental services are designed to meet every traveler’s needs."
        },
        {
          "name": "Pune to Goa Drop Taxi",
          description: "If you're looking for a simple drop from Pune to Goa, AB Ghule Cabs offers efficient and affordable drop taxi services. You can book a one-way taxi ride with us and enjoy a comfortable trip without worrying about the return journey."
        },
        {
          "name": "Pune to Goa Cab Cost",
          description: "AB Ghule Cabs offers affordable pricing for your Pune to Goa cab ride. The cost is dependent on the type of vehicle you choose, the duration of your travel, and any additional services. Get in touch with us for an exact estimate based on your specific requirements."
        },
        {
          "name": "Pune to Goa Cab Booking",
          description: "Booking a cab for your Pune to Goa journey is easy and convenient with AB Ghule Cabs. Our online platform allows you to make quick reservations, and our customer service team is always available to assist with your booking."
        },
        {
          "name": "Pune to Goa Cab Package",
          description: "For those looking for a tailored experience, AB Ghule Cabs offers customized cab packages. Whether you need a one-day trip or a multiple-day tour, we can arrange a suitable package with all-inclusive services. Choose a package that best suits your travel needs."
        },
        {
          "name": "Pune to Goa Taxi Rental",
          description: "Rent a taxi for your Pune to Goa journey and enjoy a comfortable ride in one of our well-maintained vehicles. Our rental services come with flexible terms, allowing you to enjoy your trip without any restrictions."
        },
        {
          "name": "Pune to Goa One-Way Taxi Fare",
          description: "The fare for one-way taxi services from Pune to Goa depends on your vehicle type and the total distance. With AB Ghule Cabs, you can enjoy a convenient one-way ride without worrying about the return fare."
        },
        {
          "name": "Pune to Goa Innova Crysta on Rent",
          description: "Travel in comfort with AB Ghule Cabs’ Innova Crysta rental for your Pune to Goa trip. Our premium vehicle offers plenty of space and comfort, ideal for families or groups. Equipped with modern amenities, the Innova Crysta ensures a luxurious journey."
        },
        {
          "name": "Pune to Goa Tempo Traveller",
          description: "For larger groups traveling to Goa, AB Ghule Cabs offers tempo traveller rentals. Our spacious vehicles are perfect for family outings or group tours, ensuring you and your companions travel together comfortably."
        },
        {
          "name": "Pune to Goa Car Hire",
          description: "Looking to hire a car for your trip to Goa? AB Ghule Cabs provides flexible car hire options with a variety of vehicles. Whether you need a budget option or a luxury ride, we can cater to all your needs."
        },
        {
          "name": "Pune to Goa Cabs Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Goa Cab. We ensure a smooth and enjoyable ride for all our customers."
        }
      ],

      tableData: [
        ["Pune to Goa Cab Service", "-Pune to Goa Cab Booking"],
        ["Pune to Goa Rental Cabs", "-Pune to Goa One-Way Cab"],
        ["Pune to Goa Round Trip Cabs", "-Pune to Goa Luxury Taxi"],
        ["Pune to Goa Cabs", "-Pune to Goa Car Rental"],
        ["Pune to Goa Taxi", "-Pune to Goa Taxi Fare"],
        ["Pune to Goa Cab Package", "-Pune to Goa Cab Fare"],
        ["Best Cab Service from Pune to Goa", "-Cab Service from Pune to Goa"],
        ["Car Hire Pune to Goa", "-One Way Cab from Pune to Goa"],
        ["Pune Goa Cab Service", "-Pune to Goa Cab Cost"],
        ["Pune to Goa Cab Charges", "-Pune to Goa Cab Booking"],
        ["Pune to Goa Cab Rental", "-Pune to Goa Cab Service Fare"],
        ["Pune to Goa Cab Service Rates", "-Pune to Goa Innova Rental"],
        ["Pune to Goa One Way Cab", "-Pune to Goa One Way Taxi"],
        ["Pune to Goa Taxi Service", "-Pune to Goa Taxi"]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Comfortable and Scenic Journey",
          WhyChoosedescription: "Enjoy a relaxing and comfortable ride with AB Ghule Cabs on your Pune to Goa trip. Our well-maintained fleet offers spacious, air-conditioned vehicles, ensuring you travel in comfort while enjoying the scenic beauty along the way."
        },
        {
          WhyChooseheading: "Experienced and Professional Drivers",
          WhyChoosedescription: "Our drivers are not only experienced but also knowledgeable about the Pune to Goa route. They ensure a safe and smooth journey, navigating the roads efficiently while providing excellent customer service."
        },
        {
          WhyChooseheading: "Affordable Pricing with No Hidden Charges",
          WhyChoosedescription: "We offer affordable pricing for your Pune to Goa cab ride with clear and transparent fare structures. Our rates are competitive, and there are no hidden charges, making it easy for you to budget your trip."
        },
        {
          WhyChooseheading: "Flexible Booking Options",
          WhyChoosedescription: "Booking a cab with AB Ghule Cabs is simple and convenient. You can book online via our website or mobile app, or you can call our customer service team for immediate assistance and personalized service."
        },
        {
          WhyChooseheading: "Timely and Punctual Service",
          WhyChoosedescription: "We understand the importance of punctuality, whether it's for business or leisure travel. Our drivers are always on time for pick-up, ensuring you reach your destination in Goa on time and without any delays."
        },
        {
          WhyChooseheading: "Safe and Secure Travel",
          WhyChoosedescription: "Your safety is our top priority. Our vehicles are regularly inspected for safety, and our drivers are trained to follow all road safety protocols. Additionally, all our vehicles are equipped with GPS for real-time tracking during the journey."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "We offer flexible services with round-the-clock availability. Whether you're planning a morning departure or need a late-night ride, AB Ghule Cabs is available 24/7 to cater to your needs."
        }
      ]
      
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a cab from Pune to Goa?',
      answer: 'Booking a cab from Pune to Goa is easy. You can book online through our website or mobile app, or simply call our customer service to make a reservation.',
    },
    {
      id: 'FAQ2',
      question: 'What types of vehicles are available for the Pune to Goa journey?',
      answer: 'We offer a range of vehicles, including sedans, SUVs, and luxury cars, so you can choose one that fits your preferences and group size. All our vehicles are clean and comfortable.',
    },
    {
      id: 'FAQ3',
      question: 'How long does the Pune to Goa trip take?',
      answer: 'The journey from Pune to Goa typically takes around 8 to 10 hours, depending on traffic conditions. Our drivers ensure a smooth and efficient drive to get you to Goa on time.',
    },
    {
      id: 'FAQ4',
      question: 'Are there any additional charges for the Pune to Goa trip?',
      answer: 'Our pricing is transparent, and there are no hidden fees. However, extra charges may apply for detours, waiting time, or special requests. Any extra charges will be clearly communicated upfront.',
    },
    {
      id: 'FAQ5',
      question: 'Can I modify my booking for the Pune to Goa trip?',
      answer: 'Yes, you can modify or cancel your booking by contacting our customer service. We\'ll be happy to assist you with any changes to your trip.',
    },
    {
      id: 'FAQ6',
      question: 'Do you provide round-trip services for Pune to Goa?',
      answer: 'Yes, we offer both one-way and round-trip cab services. You can plan your entire trip with us, and we\'ll ensure a comfortable and safe return journey as well.',
    },
    {
      id: 'FAQ7',
      question: 'How do I pay for the Pune to Goa cab ride?',
      answer: 'You can pay for your ride using multiple options such as cash, credit/debit cards, or online payment through our app or website. We offer flexible payment methods for your convenience.',
    },
    {
      id: 'FAQ8',
      question: 'Are the drivers experienced and knowledgeable about the Pune to Goa route?',
      answer: 'Yes, our drivers are well-experienced with the Pune to Goa route. They ensure that you have a safe and smooth journey and are familiar with the best routes to take for timely arrival.',
    },
    {
      id: 'FAQ9',
      question: 'Can I book a cab for a group?',
      answer: 'Yes, we offer cabs that can accommodate larger groups, ensuring everyone travels together comfortably. Let us know the number of people traveling, and we will arrange a suitable vehicle for your group.',
    },
    {
      id: 'FAQ10',
      question: 'Is the cab service available at all times for the Pune to Goa route?',
      answer: 'Yes, we offer 24/7 availability for the Pune to Goa route. Whether you need a morning pick-up or a late-night departure, we are always available to serve you.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Arun Patil',
      feedback: 'I had a wonderful experience with AB Ghule Cabs for my trip from Pune to Goa. The cab was comfortable, and the driver was very professional. We enjoyed a smooth and scenic drive, and the trip was stress-free. Highly recommend AB Ghule Cabs for long-distance journeys!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Rina Joshi',
      feedback: 'I recently traveled from Pune to Goa with AB Ghule Cabs, and I couldn’t be happier with the service. The driver was punctual, the car was well-maintained, and the entire journey was comfortable. I’ll definitely use AB Ghule Cabs for future trips!',
      rating: 5,
    },
  ];
  





  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Goa Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs</title>
  <meta name="description" content="Book your Pune to Goa Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Pune to Goa Cab Service, Pune to Goa Cab Booking, Pune to Goa Rental Cabs, Pune to Goa one-way cab, Pune to Goa Round Trip Cabs, Pune to Goa Luxury Taxi, pune to goa cabs, Pune to Goa Car Rental, Pune to Goa Taxi, Pune to Goa Taxi fare, Pune to Goa Cab Package, Pune to Goa cab fare, Best cab service from pune to Goa, Cab service from pune to Goa, Car Hire Pune to Goa, One way cab from pune to Goa, Pune Goa Cab Service, Pune to Goa Cab Cost, pune to goa cab charges, Pune to goa cab booking, pune to goa cab rental, Pune to goa cab service fare, Pune to goa cab service rates, Pune to Goa Innova Rental, Pune to Goa one way cab, Pune to goa one way taxi, Pune to goa taxi service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Goa Cabs | Affordable Taxi Booking & Car Rental Services | AB Ghule Cabs" />
  <meta property="og:description" content="Book your Pune to Goa Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-goa-cabs.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-goa-cabs" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  {/* JSON-LD Structured Data for Schema Markup */}
  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Goa Cabs",
        description: "Book your Pune to Goa Cabs with AB Ghule Cabs. Offering affordable, reliable taxi services and car rentals for one-way, round trip, and luxury taxis. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411001",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-goa-cabs",
        "logo": "https://abghulecabs.com/images/pune-to-goa-cabs.jpg",
        "image": "https://abghulecabs.com/images/pune-to-goa-cabs.jpg",
        "priceRange": "₹5000 - ₹15000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-goa-cabs",
          "priceCurrency": "INR",
          "price": "5000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "150"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi D"
            },
            "datePublished": "2024-11-15",
            "reviewBody": "I booked a round trip cab to Goa. The ride was smooth, and the driver was excellent. Highly recommended for anyone traveling to Goa from Pune!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya S"
            },
            "datePublished": "2024-10-10",
            "reviewBody": "AB Ghule Cabs offers the best and most affordable service for a Goa trip. Safe, comfortable, and timely ride. Great experience!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Goa Cabs",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5204",
            "longitude": "73.8567"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-goa-cabs"
        },
        "keywords": "Pune to Goa Cab Service, Pune to Goa Cab Booking, Pune to Goa Rental Cabs, Pune to Goa one-way cab, Pune to Goa Round Trip Cabs, Pune to Goa Luxury Taxi, pune to goa cabs, Pune to Goa Car Rental, Pune to Goa Taxi, Pune to Goa Taxi fare, Pune to Goa Cab Package, Pune to Goa cab fare, Best cab service from pune to Goa, Cab service from pune to Goa, Car Hire Pune to Goa, One way cab from pune to Goa, Pune Goa Cab Service, Pune to Goa Cab Cost, pune to goa cab charges, Pune to goa cab booking, pune to goa cab rental, Pune to goa cab service fare, Pune to goa cab service rates, Pune to Goa Innova Rental, Pune to Goa one way cab, Pune to goa one way taxi, Pune to goa taxi service"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/29.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetogoacabs;